import React from "react";
import EOpticAndCameraFeature from "../../../Model/EOpticAndCameraFeature";
import { VisibleCaptureProperty } from "../../../Model/CaptureProfile";
import { Condenser } from "../../../Model/ImagerCapabilities";
import { BasicControl } from "../ImagerFeatureControls";

type CondenserControlProps = {
  disabled: boolean;
  condenser: Condenser;
  captureProperty:  VisibleCaptureProperty  
  onChange: (value: { condenser: number }) => void;
};

export function CondenserControl({ condenser, captureProperty, disabled, onChange }: CondenserControlProps) {
  if (captureProperty.condenser == null) {
    throw new Error("Capture profile condenser is null");
  }
  return (
    <BasicControl
      disabled={disabled}
      feature="Condenser"
      id={EOpticAndCameraFeature.Condenser}
      min={condenser.minCondenser}
      max={condenser.maxCondenser}
      value={captureProperty.condenser}
      onValueChanged={(id, value) => {
        onChange({
          condenser: value,
        });
      }}
      unit="%"
      step={0.1}
    />
  );
}
